import { render, staticRenderFns } from "./PoDetail.vue?vue&type=template&id=0ff415d6&scoped=true&"
import script from "./PoDetail.vue?vue&type=script&lang=js&"
export * from "./PoDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff415d6",
  null
  
)

export default component.exports